import PropTypes from 'prop-types';
import imageAttributeShape from './imageAttributeShape';

const imageShape = {
  id: PropTypes.number.isRequired,
  attributes: PropTypes.shape(imageAttributeShape).isRequired,
};

export default imageShape;
